<div fxLayout="row" class="flex-lt-md-col">

    <div class="list-container main-container" fxFlex="100%">
        <div class="settings-wrapper">

            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                <div class="top-actions" style="position: absolute; left: 10px; top: 5px; z-index: 10;">
                    <button spinning (click)="onReloadAccountData()" mat-button>
                        <mat-icon class="spinning" matTooltip="{{'account.forceUpdate' | transloco}}">autorenew</mat-icon>
                        {{ 'account.refreshAccount' | transloco }}
                    </button>
                    <button (click)="onForceLogout()" mat-button>
                        <mat-icon matTooltip="{{'account.forceResetLogout' | transloco}}">exit_to_app</mat-icon>
                        {{ 'account.forceReset' | transloco }}
                    </button>
                </div>
            }


            <div class="d-flex-center" style="position: absolute; right: 10px; top: 5px; z-index: 10;">
                <app-local-diag [setLargeMode]="true"></app-local-diag>
                <app-theme-selector></app-theme-selector>
                <app-video-link videoLink="settings"></app-video-link>
            </div>

            <ng-template #generalContent>
                <form [formGroup]="formGroupSettings" (ngSubmit)="onSubmit(formGroup.value)" class="form" style="position: relative;">
                        <div class="settings-grid">
                        @if (isFullFeatures || (navGlobal$ | async) == '1') {

                            <div class="settings-card">
                                <div class="section-header">
                                    <mat-icon>settings_suggest</mat-icon>
                                    <span class="section-title">{{ 'general.globalVisibility' | transloco }}</span>
                                </div>
                                <div class="checkbox-group">
                                    <mat-checkbox (change)="onToggleSettings('showExperienceLevel')"
                                                  formControlName="showExperienceLevel">{{ 'general.experienceLevel2' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('largeLogo')"
                                                  formControlName="largeLogo">{{ 'general.largeLogo' | transloco }}
                                    </mat-checkbox>
                                    @if ((signStudioHelp$ | async) == '1') {
                                        <mat-checkbox (change)="onToggleSettings('showHelpEnabled')"
                                                      formControlName="showHelpEnabled">
                                            {{ 'general.showHelpTips2' | transloco }}
                                        </mat-checkbox>
                                        @if (formGroupSettings.get('showHelpEnabled')?.value) {
                                            <button type="button" mat-button class="sub-action-btn"
                                                    (click)="resetBlinking($event)"
                                                    matTooltip="clear which help videos have been watched">
                                                <mat-icon>replay</mat-icon>
                                                <span>reset watched videos</span>
                                            </button>
                                        }
                                    }
                                    @if (isFullFeatures && experienceLevel !== experienceLevelType.BEGINNER) {
                                        <mat-checkbox (change)="onToggleSettings('saveFullFeature')"
                                                      formControlName="saveFullFeature">dev features
                                        </mat-checkbox>
                                    }
                                    @if (isDev) {
                                        <mat-checkbox (change)="onToggleSettings('useDevServerPort')"
                                                      formControlName="useDevServerPort">use dev server port 9443
                                        </mat-checkbox>
                                    }
                                </div>
                            </div>

                            @if ((isFullFeatures || (navModule$ | async) == '1') && experienceLevel !== experienceLevelType.BEGINNER) {
                                    <div class="settings-card">
                                        <div class="section-header">
                                            <mat-icon>extension</mat-icon>
                                            <span class="section-title">{{ 'general.modulesVisibility' | transloco }}</span>
                                        </div>
                                        <div class="checkbox-group checkbox-group-grid">
                                            <mat-checkbox (change)="onToggleSettings('paintEnabled')"
                                                          formControlName="paintEnabled">{{ 'general.painter' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('catalogEnabled')"
                                                          formControlName="catalogEnabled">{{ 'general.catalogEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('scheduledEnabled')" formControlName="scheduledEnabled">{{ 'general.scheduler' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('eventsEnabled')"
                                                          formControlName="eventsEnabled">{{ 'general.eventsEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('fasterqEnabled')"
                                                          formControlName="fasterqEnabled">{{ 'general.fasterqEnabled' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('dashboardEnabled')" formControlName="dashboardEnabled">{{ 'general.dashboard' | transloco }}
                                            </mat-checkbox>
                                            <mat-checkbox (change)="onToggleSettings('iotEnabled')" formControlName="iotEnabled">{{ 'general.iot' | transloco }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                            }

                            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                                <div class="settings-card">
                                    <div class="section-header">
                                        <mat-icon>settings_suggest</mat-icon>
                                        <span class="section-title">{{ 'general.globalSettings' | transloco }}</span>
                                    </div>
                                    <div class="checkbox-group">
                                        <mat-checkbox (change)="onTogglePreference('newsLetter')"
                                                      formControlName="newsLetter">{{ 'general.receiveNewsLetter' | transloco }}
                                        </mat-checkbox>
                                        <mat-checkbox (change)="onTogglePreference('autoCheckForUpdates')"
                                                      formControlName="autoCheckForUpdates">{{ 'general.autoCheckForUpdates' | transloco }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            }
                        }

                        @if ((isFullFeatures || (navScene$ | async) == '1') && experienceLevel !== experienceLevelType.BEGINNER) {
                            <div class="settings-card">
                                <div class="section-header">
                                    <mat-icon>control_camera</mat-icon>
                                    <span class="section-title">{{ 'general.sceneControl' | transloco }}</span>
                                </div>
                                <div class="checkbox-group checkbox-group-grid">
                                    <mat-checkbox (change)="onToggleSettings('saveSceneManual')"
                                                  formControlName="saveSceneManual">{{ 'general.saveSceneManual' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('saveSceneTimer')"
                                                  formControlName="saveSceneTimer">{{ 'general.saveSceneTimer' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('showDirections')"
                                                  formControlName="showDirections">{{ 'general.useAutoAlignDragScene' | transloco }}
                                    </mat-checkbox>
                                    <mat-checkbox (change)="onToggleSettings('stickersAsEmbedded')"
                                                  formControlName="stickersAsEmbedded">{{ 'general.stickersAsShortcuts' | transloco }}
                                    </mat-checkbox>
                                </div>
                                <div class="slider-row">
                                    <div class="slider-container">
                                        <span class="slider-label">{{ 'general.sceneFocusOpacity' | transloco }}</span>
                                        <mat-slider discrete disableRipple color="accent"
                                                    min="1" max="100"
                                                    class="setting-slider">
                                            <input matSliderThumb formControlName="sceneOpacity" (change)="onChangeOpacity($event.target)"/>
                                        </mat-slider>
                                    </div>
                                    <div class="slider-container">
                                        <span class="slider-label">{{ 'general.sceneGuidelinesOpacity' | transloco }}</span>
                                        <mat-slider discrete disableRipple color="accent"
                                                    min="1" max="100"
                                                    class="setting-slider">
                                            <input matSliderThumb formControlName="sceneGuidelinesOpacityLevel" (change)="onChangeSceneGuidelinesOpacity($event.target)"/>
                                        </mat-slider>
                                    </div>
                                </div>
                            </div>
                        }

                            @if (experienceLevel !== experienceLevelType.BEGINNER) {
                                <div class="settings-card">
                                    <div class="section-header">
                                        <mat-icon>tv</mat-icon>
                                        <span class="section-title">{{ 'general.players' | transloco }} ( SignPlayer PWA )</span>
                                    </div>
                                    <div class="checkbox-group">
                                        <mat-checkbox (change)="onToggleSettings('restartPlayer')"
                                                      formControlName="restartPlayer">{{ 'general.restartPlayer4' | transloco }}
                                        </mat-checkbox>
                                        <mat-checkbox (change)="onToggleSettings('restartPlayerOnSceneAssignment')"
                                                      formControlName="restartPlayerOnSceneAssignment">{{ 'general.restartPlayerOnSceneAssignment2' | transloco }}
                                        </mat-checkbox>
                                    </div>
                                    <div class="slider-row">
                                        <div class="slider-container">
                                            <span class="slider-label">{{ 'general.snapshotScale' | transloco }}</span>
                                            <mat-slider discrete disableRipple color="accent"
                                                        min="0.1" max="1" step="0.1"
                                                        class="setting-slider">
                                                <input matSliderThumb formControlName="snapScale" (change)="onChangeSnapScale($event.target)"/>
                                            </mat-slider>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                </form>
            </ng-template>

            @if (experienceLevel === experienceLevelType.BEGINNER) {
                <div style="padding-top: 50px; height: 100%; overflow-y: auto;">
                    <ng-container *ngTemplateOutlet="generalContent"></ng-container>
                </div>
            } @else {
                <mat-tab-group [selectedIndex]="activeTabIndex"
                               style="padding-top: 50px; height: 100%; display: flex; flex-direction: column;">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon style="margin-right: 8px">settings</mat-icon>
                            General
                        </ng-template>
                        <ng-container *ngTemplateOutlet="generalContent"></ng-container>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px; vertical-align: middle;">
                                <defs>
                                    <linearGradient id="ai-tab-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                                        <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                                    </linearGradient>
                                </defs>
                                <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-tab-gradient)" stroke="#2C5AA0" stroke-width="1"/>
                                <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
                            </svg>
                            AI
                        </ng-template>
                        <app-ai-settings
                            [aiSettings]="aiSettings"
                            (aiSettingsChange)="onAiSettingsChange($event)">
                        </app-ai-settings>
                    </mat-tab>
                </mat-tab-group>
            }

        </div>
    </div>
        <div class="props-container flex-lt-md-100" fxFlex="285px">
            <div>
                <ng-template #forminfo>
                    <div class="container">
                        {{ post }}
                        <h1>aaa</h1>
                    </div>
                </ng-template>
            </div>
            <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" style="user-select: text">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon style="margin-right: 6px; font-size: 16px; width: 16px; height: 16px;">account_circle</mat-icon>
                        {{'general.accountInfo' | transloco}}
                    </ng-template>
                    <br/>

                    <!-- User Information Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>person</mat-icon>
                            <span class="props-section-title">User</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">email:</span>
                                <span class="props-value">{{ this.user.email }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">user name:</span>
                                <span class="props-value">{{ this.user.username }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">access:</span>
                                <span class="props-value">{{ isAccessDenied(this.user) === false ? 'enabled' : 'disabled' }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">status:</span>
                                <span class="props-value">{{ this.user.accountStatus }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Business Information Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>business</mat-icon>
                            <span class="props-section-title">Business</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">business id:</span>
                                <span class="props-value">{{ this.user.businessId }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">business name:</span>
                                <span class="props-value">{{ this.user?.businessName }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">domain:</span>
                                <span class="props-value">{{ this.user?.businessDomain }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">reseller id:</span>
                                <span class="props-value">{{ this.user.resellerId }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">payer id:</span>
                                <span class="props-value">{{ this.user?.payerId }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">reseller status:</span>
                                <span class="props-value">{{ this.user?.accountStatusReseller }}</span>
                            </div>
                        </div>
                    </div>

                    @if (experienceLevel !== experienceLevelType.BEGINNER) {
                        <!-- Network & Server Section -->
                        <div class="props-section">
                            <div class="props-section-header">
                                <mat-icon>cloud</mat-icon>
                                <span class="props-section-title">Network</span>
                            </div>
                            <div class="props-section-content">
                                <div class="props-item">
                                    <span class="props-label">ip address:</span>
                                    <span class="props-value">{{ this.user?.ip }}</span>
                                </div>
                                <div class="props-item">
                                    <span class="props-label">protocol:</span>
                                    <span class="props-value">{{ this.appSettings.protocol }}</span>
                                </div>
                                <div class="props-item">
                                    <span class="props-label">private server:</span>
                                    <span class="props-value">{{ this.privateServer }}</span>
                                </div>
                                <div class="props-item">
                                    <span class="props-label">LDAP:</span>
                                    <span class="props-value">{{ this.ldapServer }}</span>
                                </div>
                                <div class="props-item">
                                    <span class="props-label">offline mode:</span>
                                    <span class="props-value">{{ this.appSettings.workOffline }}</span>
                                </div>
                            </div>
                        </div>
                    }

                    <br/>
                    <mat-divider></mat-divider>
                </mat-tab>
                @if (experienceLevel !== experienceLevelType.BEGINNER) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon style="margin-right: 6px; font-size: 16px; width: 16px; height: 16px;">terminal</mat-icon>
                        {{'general.development' | transloco}}
                    </ng-template>
                    <br/>

                    <div (click)="openLink()" class="linkable">
                        <div matTooltip="Angular ROCKS!!!" fxLayout="row" fxLayoutAlign="center center">
                            <div style="background-color: white; width: 57px; height: 70px; border: red 2px solid">
                                <fa-icon style="position: relative; left: -11px" size="1x" class="angular" [icon]="faAngular"></fa-icon>
                            </div>
                        </div>
                    </div>
                    <br/>

                    <!-- Framework Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>code</mat-icon>
                            <span class="props-section-title">Framework</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">runtime:</span>
                                <span class="props-value">Angular.io</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">ng version:</span>
                                <span class="props-value">{{ version }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">build tool:</span>
                                <span class="props-value">ng-cli</span>
                            </div>
                        </div>
                    </div>

                    <!-- Application Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>apps</mat-icon>
                            <span class="props-section-title">Application</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">SignStudio:</span>
                                <span class="props-value">{{ appVersion }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">mediaCLOUD:</span>
                                <span class="props-value">{{ cloudVersion }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">dev mode:</span>
                                <span class="props-value">{{ devMode }}</span>
                            </div>
                            @if (isDev) {
                                <div class="props-item">
                                    <span class="props-label">dev server port: </span>
                                    <span class="props-value">{{ formGroupSettings.get('useDevServerPort')?.value ? '9443 (dev)' : '443 (prod)' }}</span>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- About Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>info</mat-icon>
                            <span class="props-section-title">About</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">license:</span>
                                <span class="props-value">GNU+ modified</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">origin:</span>
                                <span class="props-value">USA</span>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <mat-divider></mat-divider>
                    <button style="width: 100%; opacity: 0.01; margin-top: 300px" (click)="testError()" mat-flat-button>
                        <mat-icon>bug_report</mat-icon>
                        test dev
                    </button>

                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon style="margin-right: 6px; font-size: 16px; width: 16px; height: 16px;">desktop_windows</mat-icon>
                        {{'general.os' | transloco}}
                    </ng-template>
                    <br/>

                    <!-- Operating System Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>computer</mat-icon>
                            <span class="props-section-title">Operating System</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">family:</span>
                                <span class="props-value">{{ this.os?.family }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">type:</span>
                                <span class="props-value">{{ this.os?.name1 }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">version:</span>
                                <span class="props-value">{{ this.os?.version }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">os version:</span>
                                <span class="props-value">{{ os?.info?.os?.version }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Hardware Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>memory</mat-icon>
                            <span class="props-section-title">Hardware</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">architecture:</span>
                                <span class="props-value">{{ os?.info?.os?.architecture }}</span>
                            </div>
                            <div class="props-item">
                                <span class="props-label">layout:</span>
                                <span class="props-value">{{ os?.info?.layout }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Browser Section -->
                    <div class="props-section">
                        <div class="props-section-header">
                            <mat-icon>language</mat-icon>
                            <span class="props-section-title">Browser</span>
                        </div>
                        <div class="props-section-content">
                            <div class="props-item">
                                <span class="props-label">user agent:</span>
                                <span class="props-value">{{ os?.uaSting }}</span>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <mat-divider></mat-divider>
                </mat-tab>
                }
            </mat-tab-group>
        </div>
</div>


<!--<p class="actions">-->
<!--    <button mat-raised-button color="accent" routerLink="/overview">-->
<!--        <mat-icon>keyboard_arrow_left</mat-icon>-->
<!--        back</button>-->
<!--    <button *ngIf="!enterpriseMode" mat-raised-button color="warn" (click)="openSearchFormDialog()">-->
<!--        <mat-icon>cloud_upload</mat-icon>-->
<!--        enterprise upgrade-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="createUser()">-->
<!--        <mat-icon>speaker_notes</mat-icon>-->
<!--        enterprise report-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="deleteUser()">-->
<!--        <mat-icon>report</mat-icon>-->
<!--        enterprise termination-->
<!--    </button>-->
<!--</p>-->


<!-- test code for Alon -->
<!--                    <input type="button" value="callback" onClick="my1('value1')" />-->
<!--                    <script type="text/javascript">-->
<!--                        function testEcho(v2) {-->
<!--                            alert(v2);-->
<!--                            return "ggg";-->
<!--                        }-->
<!--                        function my1(v2) {-->
<!--                            Android.fromJS("123");-->
<!--                        }-->
<!--                    </script>-->
<!--                    <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">-->


<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="5" formControlName="description"></textarea>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker  #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item.viewValue}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                        <div class="pull-right" style="position: relative; top: -15px; padding: 30px">-->
<!--                            <span style="margin-right: 30px" class="pull-right">{{'general.youreMoji2' | transloco}}</span>-->
<!--                            <br/>-->
<!--                            <canvas width="140" height="140" [attr.data-jdenticon-value]="this.user.name"></canvas>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" fxLayout.xs="column" class="form-element">-->
<!--                            <div fxFlex="120px" fxFlex.xs>-->
<!--                                <img class="avatar" [src]="avatarSrc || model.avatarURL">-->
<!--                            </div>-->
<!--                            <div fxFlex="24px" fxFlex.xs="10px"></div>-->
<!--                            <div class="actions" fxFlex>-->
<!--                                <input #avatarInput class="hidden" type="file" accept="image/png, image/jpeg" (change)="selectAvatar($event.target.files)">-->
<!--                                <button mat-raised-button color="primary" (click)="avatarInput.click()">{{'general.select' | transloco}}</button>-->
<!--                                <button mat-raised-button color="accent" (click)="updateAvatar()" [disabled]="!avatarFile || avatarInvalid || uploaded"-->
<!--                                        [matTooltip]="uploaded ? ('general.avatarUpdated' | transloco) : avatarFile ? ('general.avatarClick' | transloco) : ('general.noFile' | transloco)"-->
<!--                                        matTooltipPosition="right">-->
<!--                                    {{uploaded ? 'Updated' : 'Update'}}-->
<!--                                </button>-->
<!--                                <div class="error-wrapper">-->
<!--                                    <mat-error>-->
<!--                                        <ng-template [ngIf]="avatarTooSmall">-->
<!--                                            {{'general.tooLarge' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                        <ng-template [ngIf]="avatarTooLarge">-->
<!--                                            {{'general.tooSmall' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                    </mat-error>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                <div class="container" *ngIf="!post; else forminfo" novalidate>-->
<!--                    <form [formGroup]="formGroup" class="form">-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" [matTextareaAutosize]="true" [matAutosizeMinRows]="2" [matAutosizeMaxRows]="5" formControlName="description"></textarea>-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item['viewValue']}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                    </form>-->
<!--                </div>-->
